import {
    createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

const hepAdapter = createEntityAdapter({})

const initialState = hepAdapter.getInitialState()

export const hepApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getHep: builder.query({
            query: () => ({
                url: '/hep',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            transformResponse: responseData => {
                const loadedHep = responseData.map(hep => {
                    hep.id = hep._id
                    return hep
                });
                return hepAdapter.setAll(initialState, loadedHep)
            },
            providesTags: (result, error, arg) => {
                if (result?.ids) {
                    return [
                        { type: 'Hep', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'Hep', id }))
                    ]
                } else return [{ type: 'Hep', id: 'LIST' }]
            }
        }),
        addNewHep: builder.mutation({
            query: initialHep => ({
                url: '/hep',
                method: 'POST',
                body: {
                    ...initialHep,
                }
            }),
            invalidatesTags: [
                { type: 'Hep', id: "LIST" }
            ]
        }),
        updateHep: builder.mutation({
            query: initialHep => ({
                url: '/hep',
                method: 'PATCH',
                body: {
                    ...initialHep,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Hep', id: arg.id }
            ]
        }),
        deleteHep: builder.mutation({
            query: ({ id }) => ({
                url: `/hep`,
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Hep', id: arg.id }
            ]
        }),
    }),
})

export const {
    useGetHepQuery,
    useAddNewHepMutation,
    useUpdateHepMutation,
    useDeleteHepMutation,
} = hepApiSlice

// returns the query result object
export const selectHepResult = hepApiSlice.endpoints.getHep.select()

// creates memoized selector
const selectHepData = createSelector(
    selectHepResult,
    HepResult => HepResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllHep,
    selectById: selectHepById,
    selectIds: selectHepIds
    // Pass in a selector that returns the notes slice of state
} = hepAdapter.getSelectors(state => selectHepData(state) ?? initialState)